import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const sandboxBundlerBifrostRLLRoute: InvariantJiraRoute = {
	name: 'sandbox-bundler-bifrost-rll',
	path: '/jira/software/sandbox/bundler-bifrost/rll',
	exact: true,
};
